const origin = window.location.origin;
const IAM_URL = process.env.VUE_APP_IAM_URL;
const CLIENT_ID = process.env.VUE_APP_IAM_CLIENT_ID

const REDIRECT_URI = `${encodeURIComponent(`${origin}/#/signin`)}`
export const goIAMLogin = () => {
  const href = `${IAM_URL}/idp/authCenter/authenticate?response_type=code&state=1&redirect_uri=${REDIRECT_URI}&client_id=${CLIENT_ID}`
  window.location.href = href;
}

export const IAMLogout = () => {
  const href = `${IAM_URL}/idp/authCenter/GLO?redirectToLogin=true&redirectToUrl=${REDIRECT_URI}`
  window.location.href = href;
}